export default __webpack_public_path__ + "static/media/Camion2-t.8a726ca7.png";